var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card page-max" },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: { model: _vm.ruleForm, "label-width": "180px" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品品牌" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.ruleForm.source == 2,
                        clearable: "",
                        placeholder: "请选择",
                        filterable: "",
                        "filter-method": _vm.handleAgreementSearch,
                      },
                      on: { change: _vm.getShopLists },
                      model: {
                        value: _vm.ruleForm.brandId,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "brandId", $$v)
                        },
                        expression: "ruleForm.brandId",
                      },
                    },
                    _vm._l(_vm.brandOption, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.brandStr, value: item.id },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.ruleForm.source == 2
                    ? _c("div", { staticStyle: { color: "#999" } }, [
                        _vm._v("副司令商品不可编辑品牌名称！"),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "主图：" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: {
                          click: function ($event) {
                            return _vm.modalPicTap("1")
                          },
                        },
                      },
                      [
                        _vm.ruleForm.albumPic
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", {
                                attrs: { src: _vm.ruleForm.albumPic },
                              }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.ruleForm.albumPic
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: { color: "red", "font-size": "16px" },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("albumPic")
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "蛋糕名称：",
                    prop: "name",
                    rules: [
                      {
                        required: true,
                        message: "请填写",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写" },
                    model: {
                      value: _vm.ruleForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "name", $$v)
                      },
                      expression: "ruleForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "规格信息", prop: "specList" } },
                [
                  _c(
                    "el-table",
                    {
                      ref: "tableListRef",
                      staticClass: "table",
                      attrs: {
                        data: _vm.ruleForm.specList,
                        size: "mini",
                        "highlight-current-row": "",
                        "header-cell-style": { fontWeight: "bold" },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "size",
                          label: "尺寸",
                          "min-width": "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "weight",
                          label: "重量",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "usedToEat",
                          label: "适用人数",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "bidPrice",
                          label: "结算价",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "sellPrice",
                          label: "建议售价",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "price",
                          label: "默认售价",
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input-number", {
                                  attrs: {
                                    min: 0,
                                    controls: false,
                                    size: "mini",
                                  },
                                  model: {
                                    value: scope.row.price,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "price", $$v)
                                    },
                                    expression: "scope.row.price",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "status",
                          label: "是否展示",
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": 1,
                                    "inactive-value": 0,
                                    "active-text": "展示",
                                    "inactive-text": "隐藏",
                                  },
                                  model: {
                                    value: scope.row.status,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "status", $$v)
                                    },
                                    expression: "scope.row.status",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "下单须知：", prop: "orderRule" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.ruleForm.orderRule,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "orderRule", $$v)
                      },
                      expression: "ruleForm.orderRule",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "城市服务：",
                    prop: "cityType",
                    rules: [
                      {
                        required: true,
                        message: "请填写",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      on: { change: _vm.getShopLists },
                      model: {
                        value: _vm.ruleForm.cityType,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "cityType", $$v)
                        },
                        expression: "ruleForm.cityType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("支持配送城市"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("不支持配送城市"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "选择城市：", prop: "cityCode" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: _vm.ruleForm.source == 2,
                      clearable: "",
                      options: _vm.addresData,
                      props: {
                        value: "id",
                        label: "name",
                        children: "child",
                        multiple: true,
                      },
                    },
                    on: { change: _vm.getShopLists },
                    model: {
                      value: _vm.ruleForm.cityCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "cityCode", $$v)
                      },
                      expression: "ruleForm.cityCode",
                    },
                  }),
                  _vm._v(" "),
                  _vm.ruleForm.cityType
                    ? _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.ruleForm.cityType == 1
                              ? "只有选中的城市才能配送"
                              : "选中城市不配送"
                          )
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "支持门店：",
                    prop: "storeType",
                    rules: [
                      {
                        required: true,
                        message: "请填写",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.ruleForm.storeType,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "storeType", $$v)
                        },
                        expression: "ruleForm.storeType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("所有门店通用"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("部分门店可用"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("部分门店不可用"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              [2, 3].includes(_vm.ruleForm.storeType)
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "选择门店：",
                        prop: "storeIds",
                        rules: [
                          {
                            required: true,
                            message: "请填写",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _vm.ruleForm.cityCode && _vm.ruleForm.cityCode.length
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: true,
                                clearable: "",
                                placeholder: "请选择",
                                filterable: "",
                                "filter-method": _vm.handleAgreementSearch,
                              },
                              model: {
                                value: _vm.ruleForm.storeIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "storeIds", $$v)
                                },
                                expression: "ruleForm.storeIds",
                              },
                            },
                            _vm._l(_vm.shopLists, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.storeName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          )
                        : _c("div", [_vm._v("请先选择城市！")]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticStyle: { "text-align": "center" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.loading },
                        on: {
                          click: function ($event) {
                            return _vm.handerSubmit("ruleForm")
                          },
                        },
                      },
                      [_vm._v("确认提交")]
                    ),
                    _vm._v(" "),
                    _c("el-button", { on: { click: _vm.goReturn } }, [
                      _vm._v("返回列表"),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }